// Badge «righe ridotte» in testata della pagina ordine (Shopify).
//
// Shopify tiene `quantity` anche per le unita' tolte (modifica ordine) o
// rimborsate: OM non le sottrae dalle righe, perche' il documento fiscale vale
// il totale incassato. Senza questo avviso l'operatore ordinerebbe al fornitore
// anche la merce che il cliente non ha piu'. Detection-only, nessuna scrittura.
import type { Order } from "../../types";

export function RigheRidotteBadge({ order }: { order: Order }) {
  const righe = order.righeRidotte ?? [];
  if (righe.length === 0) return null;
  const dettaglio = righe
    .map((r) => `${r.sku || "riga"}: ne restano ${r.rimaste} su ${r.ordinate}`)
    .join("; ");

  // Fondo pieno + testo bianco come gli altri badge di questa pagina.
  return (
    <span
      data-testid="righe-ridotte-badge"
      title={`Unità tolte o rimborsate dopo l'ordine. Non ordinare al fornitore le unità tolte. ${dettaglio}.`}
      className="inline-flex shrink-0 items-center gap-1 rounded-full bg-red px-2 py-px text-[10px] font-semibold uppercase tracking-[0.04em] text-white"
    >
      Righe ridotte: {dettaglio}
    </span>
  );
}
